<template>
    <div class="nadaba-loader" v-show="loading">
      <div class="cst-bank-spinner">
        <div class="cst-bank-spinner-bounce1"></div>
        <div class="cst-bank-spinner-bounce2"></div>
        <div class="cst-bank-spinner-bounce3"></div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'GStockLoader',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
 .nadaba-loader {
    position: absolute;
    display: flex;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    opacity: 0.8;
    background-color: rgba(255, 255, 255, 0.95);
    z-index: 99;
    .cst-bankspinner {
      width: 70px;
      text-align: center;
    }
    .cst-bank-spinner > div {
      width: 5px;
      height: 5px;
      background-color: #333;

      border-radius: 100%;
      display: inline-block;
      -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
      animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .cst-bank-spinner .cst-bank-spinner-bounce1 {
      -webkit-animation-delay: -0.32s;
      animation-delay: -0.32s;
    }

    .cst-bank-spinner .cst-bank-spinner-bounce2 {
      -webkit-animation-delay: -0.16s;
      animation-delay: -0.16s;
    }

    @-webkit-keyframes sk-bouncedelay {
      0%,
      80%,
      100% {
        -webkit-transform: scale(0);
      }
      40% {
        -webkit-transform: scale(1);
      }
    }

    @keyframes sk-bouncedelay {
      0%,
      80%,
      100% {
        -webkit-transform: scale(0);
        transform: scale(0);
      }
      40% {
        -webkit-transform: scale(1);
        transform: scale(1);
      }
    }
  }
</style>